import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

import {
  SGKZ011AService,
  Sgkz011aRequest,
  Sgkz011aResponse
} from 'sg-api';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd020dSgkz011aService {

  private _rsesult$ = new Subject<Sgkz011aResponse>();

  constructor(
    private sGKZ011AService: SGKZ011AService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * ユーザ情報取得API呼び出し
   *
   * @param userId ユーザID
   * @memberof UsedSgkd020dSgkz011aService
   */
  doSgkz011a(userId: string): Observable<Sgkz011aResponse>{
    // リクエスト生成
    let request: Sgkz011aRequest = {
      /** ユーザID */
      userId: userId
    };

    return this.sGKZ011AService.kz10RSGKZ011APost(this.apiCommonService.setRequestCommon(request), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._rsesult$.next(response.body);
          return response.body;
          //return true;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD045A');
          return throwError(err.message);
        }
      )
    );
  }
}
